export default __webpack_public_path__ + "static/media/mtg2.fc03c5a6.png";